import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { filter, switchMap, take, takeWhile } from 'rxjs';

import { AsyncJobSelectors, AsyncJobStatus } from '@recruitee/async-job/data';
import { filterBoolean } from '@recruitee/common';

import { OfferBulkSelectors } from '../store/bulk-actions/bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class OfferBulkActionsService {
  constructor(private store: Store) {}

  public trackByCorrelationId(correlationId: string) {
    return this.store.select(OfferBulkSelectors.byId(correlationId)).pipe(
      filterBoolean,
      filter(entity => !!entity.uuid),
      take(1),
      switchMap(({ uuid }) => this.store.select(AsyncJobSelectors.byId(uuid))),
      filterBoolean,
      takeWhile(job => job.status !== AsyncJobStatus.FINISHED, true),
    );
  }
}
